import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import OrgAdminResultRelease from '../../../modules/result/@org-admin/results-release/OrgAdminResultRelease';

const OrgAdminResultReleaseList = () => (
  <>
    <TitleHeader title="Results" />

    <ContentTemplate type="full">
      <OrgAdminResultRelease />
    </ContentTemplate>
  </>
);
export default OrgAdminResultReleaseList;
